import * as Yup from "yup";

const ProductBrandSchema = () => Yup.object().shape({
  brand_ids: Yup
    .array()
    .label("Brands")
});

export default ProductBrandSchema;
